var bighouse = bighouse || {};

bighouse.searchCarousel = (function () {

    var bSetAsMobile = false;

    function init() {
        initCarousels();

        var debounceResize = util.debounce(resizeCarousels, 200);
        $(window).on('resize', debounceResize);
    }


    function initCarousels(){

        imageSize();

        $('.js-searchCarousel').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            dots: true,
            prevArrow: '<button type="button" class="SearchResults-arrows SearchResults-arrows--prev"><span class="u-visuallyHidden">Previous</span></button>',
            nextArrow: '<button type="button" class="SearchResults-arrows SearchResults-arrows--next"><span class="u-visuallyHidden">Next</span></button>',
            rows: 0,
            infinite: true
        });


        $('.js-searchCarouselLink').on('click', function(e){
          window.location = $(this).attr('data-url');
          e.preventDefault();
        });

    }

    function imageSize(){

        //classic-ant-thumb12.jpeg?width=407&height=407&mode=crop&quality=80"

        var docWidth = $(document).width();
        var bActuallyMobile = (docWidth <= 600);

        //var cropParams = (bActuallyMobile) ? '?width=560&height=273&mode=crop' : '?width=890&height=450&mode=crop';
        var cropParams = (bActuallyMobile) ? '?width=560&height=273&mode=max' : '?width=890&height=450&mode=max';


        if(  (bActuallyMobile && !bSetAsMobile) || ( !bActuallyMobile && bSetAsMobile) ){
        
            $('.js-searchCarousel .SearchResults-carouselSlide img').each(function(){
                let image = $(this).attr('data-lazy');

                //if the data-lazy attribute does not exist the image has already been loaded. Therefore we don't want to needlessly load in another image on mobile. 
                //This should only happen if going from mobile to desktop size (as it will look really grainy).
                if(image === undefined && !bActuallyMobile) { 
                    image = $(this).attr('src');
                    $(this).attr('src', image.split('?')[0] + cropParams);
                } else if(image !== undefined) {
                    $(this).attr('data-lazy', image.split('?')[0] + cropParams);
                }
                
            });

        }

        bSetAsMobile = bActuallyMobile;
    }


    function resizeCarousels(){
        $('.js-searchCarousel').slick('refresh');
        imageSize();
    }


    return {
        init: init,
        resizeCarousels: resizeCarousels
    };
})();
